import { IConsumptionState, initialConsumptionState } from "@edp-store/state/consumption.state";
import { EConsumptionActions, ConsumptionActions } from "@edp-store/actions/consumption.actions";

export function consumptionReducers(state = initialConsumptionState, action: ConsumptionActions): IConsumptionState {
    switch (action.type) {
        case EConsumptionActions.SetConsumptions: {
            return {
                ...state,
                consumptions: {
                    data: action.payload,
                    lastAPIError: null,
                },
            };
        }
        case EConsumptionActions.ConsumptionsAPIError: {
            return {
                ...state,
                consumptions: {
                    ...state.consumptions,
                    lastAPIError: action.error,
                },
            };
        }
        case EConsumptionActions.SetConsumptionsChartData: {
            return {
                ...state,
                consumptions: {
                    ...state.consumptions,
                    chartData: action.payload,
                },
            };
        }
        case EConsumptionActions.SetConsumptionsPeriod: {
            return {
                ...state,
                consumptions: {
                    ...state.consumptions,
                    period: action.payload,
                },
            };
        }
        case EConsumptionActions.SetConsumptionHistory: {
            return {
                ...state,
                consumptions: {
                    ...state.consumptions,
                    consumptionHistory: action.payload,
                },
            };
        }
        case EConsumptionActions.SetMobieConsumptionHistory: {
            return {
                ...state,
                consumptions: {
                    ...state.consumptions,
                    mobieConsumptionHistory: action.payload,
                },
            };
        }
        case EConsumptionActions.SetConsumptionEvolution: {
            return {
                ...state,
                consumptionEvolution: action.payload,
            };
        }
        case EConsumptionActions.SetConsumptionSelected: {
            return {
                ...state,
                consumptionSelected: action.payload,
            };
        }
        case EConsumptionActions.SetMobieCardList: {
            return {
                ...state,
                mobieCardList: action.payload,
            };
        }
        case EConsumptionActions.SetActiveTab: {
            return {
                ...state,
                activeTab: action.payload,
            };
        }
        case EConsumptionActions.SetMobieConsumptions: {
            return {
                ...state,
                mobieConsumptions: action.payload,
            };
        }
        
        default:
            return state;
    }
}
